export default __webpack_public_path__ + "static/media/cart4.957ad81a.svg";